/* eslint-disable */
// Auto-generated by scripts/generate-shared-ui-meta.mjs
const sharedUiMetadata = [
  {
    "id": "button",
    "label": "Button",
    "sourceFiles": [
      "src/Components/ui/button.tsx",
      "src/Components/Common/Tailwind/Button.tsx"
    ],
    "usages": [
      {
        "pageFile": "src/NotFoundPage.jsx",
        "routePaths": [
          "*"
        ]
      },
      {
        "pageFile": "src/pages/ApiTester/index.jsx",
        "routePaths": [
          "/api-tester"
        ]
      },
      {
        "pageFile": "src/pages/AppDownload.jsx",
        "routePaths": [
          "/app-download"
        ]
      },
      {
        "pageFile": "src/pages/Authentication/KakaoPhoneInput.jsx",
        "routePaths": [
          "/auth/kakao-phone-input"
        ]
      },
      {
        "pageFile": "src/pages/Authentication/Login.jsx",
        "routePaths": [
          "/login"
        ]
      },
      {
        "pageFile": "src/pages/Authentication/PhoneLogin.jsx",
        "routePaths": [
          "/phone-login"
        ]
      },
      {
        "pageFile": "src/pages/Authentication/SecretLogin.jsx",
        "routePaths": [
          "/admin-login"
        ]
      },
      {
        "pageFile": "src/pages/CampMap/CampMap.jsx",
        "routePaths": [
          "/camp-map"
        ]
      },
      {
        "pageFile": "src/pages/Detail/AddOptionsDetail.jsx",
        "routePaths": [
          "/add-options-detail/:id"
        ]
      },
      {
        "pageFile": "src/pages/Detail/CancelOptionsDetail.jsx",
        "routePaths": [
          "/cancel-options-detail/:id"
        ]
      },
      {
        "pageFile": "src/pages/EventProduct/Reception/index.jsx",
        "routePaths": [
          "/reception/:type"
        ]
      },
      {
        "pageFile": "src/pages/Events/AmazingPass/index.jsx",
        "routePaths": [
          "/event-amazingpass"
        ]
      },
      {
        "pageFile": "src/pages/Events/Coupon/index.jsx",
        "routePaths": [
          "/event-coupon/:id"
        ]
      },
      {
        "pageFile": "src/pages/Events/Voucher/index.jsx",
        "routePaths": [
          "/event-voucher/:id"
        ]
      },
      {
        "pageFile": "src/pages/Gift/Coupon/index.jsx",
        "routePaths": [
          "/gift/coupon/:id"
        ]
      },
      {
        "pageFile": "src/pages/Gift/Reservation/index.jsx",
        "routePaths": [
          "/gift/reservation/:id"
        ]
      },
      {
        "pageFile": "src/pages/Gift/Ticket/index.jsx",
        "routePaths": [
          "/gift/ticket/:id"
        ]
      },
      {
        "pageFile": "src/pages/Gift/Voucher/index.jsx",
        "routePaths": [
          "/gift/voucher/:id"
        ]
      },
      {
        "pageFile": "src/pages/GroupReservation/GroupReservationApplyPage.tsx",
        "routePaths": [
          "/group-reservation",
          "/group-reservation/agency/:token"
        ]
      },
      {
        "pageFile": "src/pages/Inquiry/Detail/index.jsx",
        "routePaths": [
          "/inquiry/detail/:id"
        ]
      },
      {
        "pageFile": "src/pages/Inquiry/Form/index.jsx",
        "routePaths": [
          "/inquiry/form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Inquiry/List/index.jsx",
        "routePaths": [
          "/inquiry"
        ]
      },
      {
        "pageFile": "src/pages/Landing/DisplayMenuPage.tsx",
        "routePaths": [
          "/display-menu"
        ]
      },
      {
        "pageFile": "src/pages/Landing/SmartLanding.jsx",
        "routePaths": [
          "/"
        ]
      },
      {
        "pageFile": "src/pages/Legal/LegalDocumentPage.tsx",
        "routePaths": [
          "/legal/:kind"
        ]
      },
      {
        "pageFile": "src/pages/LodgingPackage/packageDetail.jsx",
        "routePaths": [
          "/lodging-package/:id"
        ]
      },
      {
        "pageFile": "src/pages/Notice/NoticeDetail/index.jsx",
        "routePaths": [
          "/notice/detail/:id"
        ]
      },
      {
        "pageFile": "src/pages/Notice/NoticeForm/index.jsx",
        "routePaths": [
          "/notice/form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Notice/NoticeList/index.jsx",
        "routePaths": [
          "/notice"
        ]
      },
      {
        "pageFile": "src/pages/Notification/index.jsx",
        "routePaths": [
          "/notification"
        ]
      },
      {
        "pageFile": "src/pages/Order/AddOptions/index.jsx",
        "routePaths": [
          "/add-options-order"
        ]
      },
      {
        "pageFile": "src/pages/Order/AddOptions/OrderDone.jsx",
        "routePaths": [
          "/add-options-order-done/:orderId"
        ]
      },
      {
        "pageFile": "src/pages/Order/OrderPackage/index.jsx",
        "routePaths": [
          "/order"
        ]
      },
      {
        "pageFile": "src/pages/Order/OrderPackage/OrderDone.jsx",
        "routePaths": [
          "/order-done/:orderId"
        ]
      },
      {
        "pageFile": "src/pages/Order/OrderPackage/OrderFail.jsx",
        "routePaths": [
          "/order-fail"
        ]
      },
      {
        "pageFile": "src/pages/Order/OrderShopping/index.jsx",
        "routePaths": [
          "/order-shop"
        ]
      },
      {
        "pageFile": "src/pages/Order/OrderTicketMultiPage/MultiOrderDone.jsx",
        "routePaths": [
          "/order-done-multi/:orderId"
        ]
      },
      {
        "pageFile": "src/pages/Package/index.jsx",
        "routePaths": [
          "/package",
          "/reservation"
        ]
      },
      {
        "pageFile": "src/pages/Package/PackageItemPage.jsx",
        "routePaths": [
          "/package/:id"
        ]
      },
      {
        "pageFile": "src/pages/Package/PrivatePackageOfferPage.jsx",
        "routePaths": [
          "/private-package/:token"
        ]
      },
      {
        "pageFile": "src/pages/Promotion/b2bCoupon/index.jsx",
        "routePaths": [
          "/promotion/coupon/:share_pin_code"
        ]
      },
      {
        "pageFile": "src/pages/Promotion/B2BPrecoupon/index.jsx",
        "routePaths": [
          "/promotion/precoupon/:share_pin_code"
        ]
      },
      {
        "pageFile": "src/pages/Promotion/B2BVoucher/index.jsx",
        "routePaths": [
          "/promotion/voucher/:share_pin_code"
        ]
      },
      {
        "pageFile": "src/pages/Shop/ShoppingDetail.jsx",
        "routePaths": [
          "/shop/:id"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/CustomerOrder.jsx",
        "routePaths": [
          "/table-order"
        ]
      },
      {
        "pageFile": "src/pages/Ticket/Ticket.jsx",
        "routePaths": [
          "/ticket"
        ]
      },
      {
        "pageFile": "src/pages/Ticket/TicketItemPage.jsx",
        "routePaths": [
          "/ticket/:id"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/AmazingPass/amazingpassOrder.jsx",
        "routePaths": [
          "/amazingpass/order"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/AmazingPass/index.jsx",
        "routePaths": [
          "/amazingpass"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/B2BCoupon/B2BInfo.jsx",
        "routePaths": [
          "/my-page/b2b-info/coupon"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/B2BCoupon/B2BTabView.jsx",
        "routePaths": [
          "/my-page/b2b/coupon"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/B2BPreCoupon/B2BPreCouponInfo.jsx",
        "routePaths": [
          "/my-page/b2b-info/precoupon"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/B2BPreCoupon/B2BPreCouponTabView.jsx",
        "routePaths": [
          "/my-page/b2b/precoupon"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/B2BVoucher/B2BVoucherInfo.jsx",
        "routePaths": [
          "/my-page/b2b-info/voucher"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/B2BVoucher/B2BVoucherTabView.jsx",
        "routePaths": [
          "/my-page/b2b/voucher"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/Membership/index.jsx",
        "routePaths": [
          "/my-page/membership"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/MyPage.jsx",
        "routePaths": [
          "/my-page"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/AmazingPassPurchaseList.jsx",
        "routePaths": [
          "/my-page/amazingpass"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/CancelList.jsx",
        "routePaths": [
          "/my-page/cancel"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/GiftSendTabView.jsx",
        "routePaths": [
          "/my-page/gift-send"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/GiftTabView.jsx",
        "routePaths": [
          "/my-page/gift-box"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/ReservationList.tsx",
        "routePaths": [
          "/my-page/reservation"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/TicketPurchaseList.tsx",
        "routePaths": [
          "/my-page/ticket"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/UserVoucher.jsx",
        "routePaths": [
          "/my-page/voucher"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/Purchases.jsx",
        "routePaths": [
          "/purchases"
        ]
      }
    ]
  },
  {
    "id": "badge",
    "label": "Badge",
    "sourceFiles": [
      "src/Components/ui/badge.tsx"
    ],
    "usages": [
      {
        "pageFile": "src/pages/Landing/SmartLanding.jsx",
        "routePaths": [
          "/"
        ]
      }
    ]
  },
  {
    "id": "card",
    "label": "Card",
    "sourceFiles": [
      "src/Components/ui/card.tsx",
      "src/Components/Common/Tailwind/Card.tsx",
      "src/Components/Common/Tailwind/CardHeader.tsx",
      "src/Components/Common/Tailwind/CardBody.tsx"
    ],
    "usages": [
      {
        "pageFile": "src/pages/ApiTester/index.jsx",
        "routePaths": [
          "/api-tester"
        ]
      },
      {
        "pageFile": "src/pages/Authentication/KakaoPage.jsx",
        "routePaths": [
          "/kakao"
        ]
      },
      {
        "pageFile": "src/pages/Authentication/KakaoPhoneInput.jsx",
        "routePaths": [
          "/auth/kakao-phone-input"
        ]
      },
      {
        "pageFile": "src/pages/Authentication/PhoneLogin.jsx",
        "routePaths": [
          "/phone-login"
        ]
      },
      {
        "pageFile": "src/pages/Authentication/SecretLogin.jsx",
        "routePaths": [
          "/admin-login"
        ]
      },
      {
        "pageFile": "src/pages/CampMap/CampMap.jsx",
        "routePaths": [
          "/camp-map"
        ]
      },
      {
        "pageFile": "src/pages/Detail/AddOptionsDetail.jsx",
        "routePaths": [
          "/add-options-detail/:id"
        ]
      },
      {
        "pageFile": "src/pages/Detail/CancelOptionsDetail.jsx",
        "routePaths": [
          "/cancel-options-detail/:id"
        ]
      },
      {
        "pageFile": "src/pages/EventProduct/Reception/index.jsx",
        "routePaths": [
          "/reception/:type"
        ]
      },
      {
        "pageFile": "src/pages/Inquiry/Form/index.jsx",
        "routePaths": [
          "/inquiry/form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Landing/SmartLanding.jsx",
        "routePaths": [
          "/"
        ]
      },
      {
        "pageFile": "src/pages/Notice/NoticeDetail/index.jsx",
        "routePaths": [
          "/notice/detail/:id"
        ]
      },
      {
        "pageFile": "src/pages/Notice/NoticeForm/index.jsx",
        "routePaths": [
          "/notice/form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Notice/NoticeList/index.jsx",
        "routePaths": [
          "/notice"
        ]
      },
      {
        "pageFile": "src/pages/Order/AddOptions/OrderDone.jsx",
        "routePaths": [
          "/add-options-order-done/:orderId"
        ]
      },
      {
        "pageFile": "src/pages/Order/OrderPackage/OrderFail.jsx",
        "routePaths": [
          "/order-fail"
        ]
      },
      {
        "pageFile": "src/pages/Shop/ShoppingDetail.jsx",
        "routePaths": [
          "/shop/:id"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/B2BCoupon/B2BTabView.jsx",
        "routePaths": [
          "/my-page/b2b/coupon"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/B2BPreCoupon/B2BPreCouponTabView.jsx",
        "routePaths": [
          "/my-page/b2b/precoupon"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/B2BVoucher/B2BVoucherTabView.jsx",
        "routePaths": [
          "/my-page/b2b/voucher"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/AmazingPassPurchaseList.jsx",
        "routePaths": [
          "/my-page/amazingpass"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/CancelList.jsx",
        "routePaths": [
          "/my-page/cancel"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/GiftSendTabView.jsx",
        "routePaths": [
          "/my-page/gift-send"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/GiftTabView.jsx",
        "routePaths": [
          "/my-page/gift-box"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/UserVoucher.jsx",
        "routePaths": [
          "/my-page/voucher"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/Purchases.jsx",
        "routePaths": [
          "/purchases"
        ]
      }
    ]
  },
  {
    "id": "modal",
    "label": "Modal",
    "sourceFiles": [
      "src/Components/Common/Tailwind/Modal.tsx",
      "src/Components/Common/Tailwind/ModalHeader.tsx",
      "src/Components/Common/Tailwind/ModalBody.tsx",
      "src/Components/Common/Tailwind/ModalFooter.tsx"
    ],
    "usages": [
      {
        "pageFile": "src/NotFoundPage.jsx",
        "routePaths": [
          "*"
        ]
      },
      {
        "pageFile": "src/pages/AppDownload.jsx",
        "routePaths": [
          "/app-download"
        ]
      },
      {
        "pageFile": "src/pages/Authentication/Login.jsx",
        "routePaths": [
          "/login"
        ]
      },
      {
        "pageFile": "src/pages/CampMap/CampMap.jsx",
        "routePaths": [
          "/camp-map"
        ]
      },
      {
        "pageFile": "src/pages/Detail/AddOptionsDetail.jsx",
        "routePaths": [
          "/add-options-detail/:id"
        ]
      },
      {
        "pageFile": "src/pages/Detail/CancelOptionsDetail.jsx",
        "routePaths": [
          "/cancel-options-detail/:id"
        ]
      },
      {
        "pageFile": "src/pages/EventProduct/Reception/index.jsx",
        "routePaths": [
          "/reception/:type"
        ]
      },
      {
        "pageFile": "src/pages/Events/AmazingPass/index.jsx",
        "routePaths": [
          "/event-amazingpass"
        ]
      },
      {
        "pageFile": "src/pages/Events/Coupon/index.jsx",
        "routePaths": [
          "/event-coupon/:id"
        ]
      },
      {
        "pageFile": "src/pages/Events/Voucher/index.jsx",
        "routePaths": [
          "/event-voucher/:id"
        ]
      },
      {
        "pageFile": "src/pages/Gift/Coupon/index.jsx",
        "routePaths": [
          "/gift/coupon/:id"
        ]
      },
      {
        "pageFile": "src/pages/Gift/Reservation/index.jsx",
        "routePaths": [
          "/gift/reservation/:id"
        ]
      },
      {
        "pageFile": "src/pages/Gift/Ticket/index.jsx",
        "routePaths": [
          "/gift/ticket/:id"
        ]
      },
      {
        "pageFile": "src/pages/Gift/Voucher/index.jsx",
        "routePaths": [
          "/gift/voucher/:id"
        ]
      },
      {
        "pageFile": "src/pages/GroupReservation/GroupReservationApplyPage.tsx",
        "routePaths": [
          "/group-reservation",
          "/group-reservation/agency/:token"
        ]
      },
      {
        "pageFile": "src/pages/Inquiry/Detail/index.jsx",
        "routePaths": [
          "/inquiry/detail/:id"
        ]
      },
      {
        "pageFile": "src/pages/Inquiry/List/index.jsx",
        "routePaths": [
          "/inquiry"
        ]
      },
      {
        "pageFile": "src/pages/Landing/DisplayMenuPage.tsx",
        "routePaths": [
          "/display-menu"
        ]
      },
      {
        "pageFile": "src/pages/Landing/SmartLanding.jsx",
        "routePaths": [
          "/"
        ]
      },
      {
        "pageFile": "src/pages/Legal/LegalDocumentPage.tsx",
        "routePaths": [
          "/legal/:kind"
        ]
      },
      {
        "pageFile": "src/pages/LodgingPackage/packageDetail.jsx",
        "routePaths": [
          "/lodging-package/:id"
        ]
      },
      {
        "pageFile": "src/pages/Notice/NoticeDetail/index.jsx",
        "routePaths": [
          "/notice/detail/:id"
        ]
      },
      {
        "pageFile": "src/pages/Notice/NoticeForm/index.jsx",
        "routePaths": [
          "/notice/form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Notice/NoticeList/index.jsx",
        "routePaths": [
          "/notice"
        ]
      },
      {
        "pageFile": "src/pages/Notification/index.jsx",
        "routePaths": [
          "/notification"
        ]
      },
      {
        "pageFile": "src/pages/Order/AddOptions/index.jsx",
        "routePaths": [
          "/add-options-order"
        ]
      },
      {
        "pageFile": "src/pages/Order/AddOptions/OrderDone.jsx",
        "routePaths": [
          "/add-options-order-done/:orderId"
        ]
      },
      {
        "pageFile": "src/pages/Order/OrderPackage/OrderDone.jsx",
        "routePaths": [
          "/order-done/:orderId"
        ]
      },
      {
        "pageFile": "src/pages/Order/OrderPackage/OrderFail.jsx",
        "routePaths": [
          "/order-fail"
        ]
      },
      {
        "pageFile": "src/pages/Order/OrderShopping/index.jsx",
        "routePaths": [
          "/order-shop"
        ]
      },
      {
        "pageFile": "src/pages/Order/OrderTicketMultiPage/index.jsx",
        "routePaths": [
          "/order-ticket-multi"
        ]
      },
      {
        "pageFile": "src/pages/Order/OrderTicketMultiPage/MultiOrderDone.jsx",
        "routePaths": [
          "/order-done-multi/:orderId"
        ]
      },
      {
        "pageFile": "src/pages/Package/index.jsx",
        "routePaths": [
          "/package",
          "/reservation"
        ]
      },
      {
        "pageFile": "src/pages/Package/PackageItemPage.jsx",
        "routePaths": [
          "/package/:id"
        ]
      },
      {
        "pageFile": "src/pages/Package/PrivatePackageOfferPage.jsx",
        "routePaths": [
          "/private-package/:token"
        ]
      },
      {
        "pageFile": "src/pages/Promotion/b2bCoupon/index.jsx",
        "routePaths": [
          "/promotion/coupon/:share_pin_code"
        ]
      },
      {
        "pageFile": "src/pages/Promotion/B2BPrecoupon/index.jsx",
        "routePaths": [
          "/promotion/precoupon/:share_pin_code"
        ]
      },
      {
        "pageFile": "src/pages/Promotion/B2BVoucher/index.jsx",
        "routePaths": [
          "/promotion/voucher/:share_pin_code"
        ]
      },
      {
        "pageFile": "src/pages/Shop/ShoppingDetail.jsx",
        "routePaths": [
          "/shop/:id"
        ]
      },
      {
        "pageFile": "src/pages/TableOrder/CustomerOrder.jsx",
        "routePaths": [
          "/table-order"
        ]
      },
      {
        "pageFile": "src/pages/Ticket/TicketItemPage.jsx",
        "routePaths": [
          "/ticket/:id"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/AmazingPass/index.jsx",
        "routePaths": [
          "/amazingpass"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/B2BCoupon/B2BInfo.jsx",
        "routePaths": [
          "/my-page/b2b-info/coupon"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/B2BCoupon/B2BTabView.jsx",
        "routePaths": [
          "/my-page/b2b/coupon"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/B2BPreCoupon/B2BPreCouponInfo.jsx",
        "routePaths": [
          "/my-page/b2b-info/precoupon"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/B2BPreCoupon/B2BPreCouponTabView.jsx",
        "routePaths": [
          "/my-page/b2b/precoupon"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/B2BVoucher/B2BVoucherInfo.jsx",
        "routePaths": [
          "/my-page/b2b-info/voucher"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/B2BVoucher/B2BVoucherTabView.jsx",
        "routePaths": [
          "/my-page/b2b/voucher"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/Membership/index.jsx",
        "routePaths": [
          "/my-page/membership"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/MyPage.jsx",
        "routePaths": [
          "/my-page"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/AmazingPassPurchaseList.jsx",
        "routePaths": [
          "/my-page/amazingpass"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/CancelList.jsx",
        "routePaths": [
          "/my-page/cancel"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/CouponBook.tsx",
        "routePaths": [
          "/my-page/coupon"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/GiftSendTabView.jsx",
        "routePaths": [
          "/my-page/gift-send"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/GiftTabView.jsx",
        "routePaths": [
          "/my-page/gift-box"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/ReservationList.tsx",
        "routePaths": [
          "/my-page/reservation"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/TicketPurchaseList.tsx",
        "routePaths": [
          "/my-page/ticket"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/UserVoucher.jsx",
        "routePaths": [
          "/my-page/voucher"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/Purchases.jsx",
        "routePaths": [
          "/purchases"
        ]
      }
    ]
  },
  {
    "id": "dialog",
    "label": "Dialog",
    "sourceFiles": [
      "src/hooks/useConfirmDialog.js"
    ],
    "usages": [
      {
        "pageFile": "src/pages/Detail/AddOptionsDetail.jsx",
        "routePaths": [
          "/add-options-detail/:id"
        ]
      },
      {
        "pageFile": "src/pages/Detail/CancelOptionsDetail.jsx",
        "routePaths": [
          "/cancel-options-detail/:id"
        ]
      },
      {
        "pageFile": "src/pages/GroupReservation/GroupReservationApplyPage.tsx",
        "routePaths": [
          "/group-reservation",
          "/group-reservation/agency/:token"
        ]
      },
      {
        "pageFile": "src/pages/Inquiry/Detail/index.jsx",
        "routePaths": [
          "/inquiry/detail/:id"
        ]
      },
      {
        "pageFile": "src/pages/Inquiry/Form/index.jsx",
        "routePaths": [
          "/inquiry/form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Notice/NoticeForm/index.jsx",
        "routePaths": [
          "/notice/form/:id"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/B2BCoupon/B2BTabView.jsx",
        "routePaths": [
          "/my-page/b2b/coupon"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/B2BPreCoupon/B2BPreCouponTabView.jsx",
        "routePaths": [
          "/my-page/b2b/precoupon"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/B2BVoucher/B2BVoucherTabView.jsx",
        "routePaths": [
          "/my-page/b2b/voucher"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/AmazingPassPurchaseList.jsx",
        "routePaths": [
          "/my-page/amazingpass"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/GiftSendTabView.jsx",
        "routePaths": [
          "/my-page/gift-send"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/GiftTabView.jsx",
        "routePaths": [
          "/my-page/gift-box"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/ReservationList.tsx",
        "routePaths": [
          "/my-page/reservation"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/TicketPurchaseList.tsx",
        "routePaths": [
          "/my-page/ticket"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/UserVoucher.jsx",
        "routePaths": [
          "/my-page/voucher"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/Purchases.jsx",
        "routePaths": [
          "/purchases"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/Settings/index.tsx",
        "routePaths": [
          "/my-page/settings"
        ]
      }
    ]
  },
  {
    "id": "dropdown",
    "label": "Dropdown",
    "sourceFiles": [
      "src/Components/Common/Tailwind/Dropdown.tsx"
    ],
    "usages": [
      {
        "pageFile": "src/pages/EventProduct/Reception/index.jsx",
        "routePaths": [
          "/reception/:type"
        ]
      }
    ]
  },
  {
    "id": "form",
    "label": "Form",
    "sourceFiles": [
      "src/Components/Common/Tailwind/Form.tsx"
    ],
    "usages": [
      {
        "pageFile": "src/pages/ApiTester/index.jsx",
        "routePaths": [
          "/api-tester"
        ]
      },
      {
        "pageFile": "src/pages/Authentication/SecretLogin.jsx",
        "routePaths": [
          "/admin-login"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/B2BCoupon/B2BTabView.jsx",
        "routePaths": [
          "/my-page/b2b/coupon"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/B2BPreCoupon/B2BPreCouponTabView.jsx",
        "routePaths": [
          "/my-page/b2b/precoupon"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/B2BVoucher/B2BVoucherTabView.jsx",
        "routePaths": [
          "/my-page/b2b/voucher"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/AmazingPassPurchaseList.jsx",
        "routePaths": [
          "/my-page/amazingpass"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/GiftSendTabView.jsx",
        "routePaths": [
          "/my-page/gift-send"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/GiftTabView.jsx",
        "routePaths": [
          "/my-page/gift-box"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/ReservationList.tsx",
        "routePaths": [
          "/my-page/reservation"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/TicketPurchaseList.tsx",
        "routePaths": [
          "/my-page/ticket"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/UserVoucher.jsx",
        "routePaths": [
          "/my-page/voucher"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/Purchases.jsx",
        "routePaths": [
          "/purchases"
        ]
      }
    ]
  },
  {
    "id": "input",
    "label": "Input",
    "sourceFiles": [
      "src/Components/Common/Tailwind/Input.tsx"
    ],
    "usages": [
      {
        "pageFile": "src/pages/ApiTester/index.jsx",
        "routePaths": [
          "/api-tester"
        ]
      },
      {
        "pageFile": "src/pages/Authentication/Login.jsx",
        "routePaths": [
          "/login"
        ]
      },
      {
        "pageFile": "src/pages/Authentication/SecretLogin.jsx",
        "routePaths": [
          "/admin-login"
        ]
      },
      {
        "pageFile": "src/pages/CampMap/CampMap.jsx",
        "routePaths": [
          "/camp-map"
        ]
      },
      {
        "pageFile": "src/pages/Detail/AddOptionsDetail.jsx",
        "routePaths": [
          "/add-options-detail/:id"
        ]
      },
      {
        "pageFile": "src/pages/Detail/CancelOptionsDetail.jsx",
        "routePaths": [
          "/cancel-options-detail/:id"
        ]
      },
      {
        "pageFile": "src/pages/EventProduct/Reception/index.jsx",
        "routePaths": [
          "/reception/:type"
        ]
      },
      {
        "pageFile": "src/pages/GroupReservation/GroupReservationApplyPage.tsx",
        "routePaths": [
          "/group-reservation",
          "/group-reservation/agency/:token"
        ]
      },
      {
        "pageFile": "src/pages/Inquiry/Form/index.jsx",
        "routePaths": [
          "/inquiry/form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Landing/SmartLanding.jsx",
        "routePaths": [
          "/"
        ]
      },
      {
        "pageFile": "src/pages/LodgingPackage/packageDetail.jsx",
        "routePaths": [
          "/lodging-package/:id"
        ]
      },
      {
        "pageFile": "src/pages/Notice/NoticeForm/index.jsx",
        "routePaths": [
          "/notice/form/:id"
        ]
      },
      {
        "pageFile": "src/pages/Order/OrderShopping/index.jsx",
        "routePaths": [
          "/order-shop"
        ]
      },
      {
        "pageFile": "src/pages/Package/PackageItemPage.jsx",
        "routePaths": [
          "/package/:id"
        ]
      },
      {
        "pageFile": "src/pages/Package/PrivatePackageOfferPage.jsx",
        "routePaths": [
          "/private-package/:token"
        ]
      },
      {
        "pageFile": "src/pages/Shop/ShoppingDetail.jsx",
        "routePaths": [
          "/shop/:id"
        ]
      },
      {
        "pageFile": "src/pages/Ticket/TicketItemPage.jsx",
        "routePaths": [
          "/ticket/:id"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/B2BCoupon/B2BTabView.jsx",
        "routePaths": [
          "/my-page/b2b/coupon"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/B2BPreCoupon/B2BPreCouponTabView.jsx",
        "routePaths": [
          "/my-page/b2b/precoupon"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/B2BVoucher/B2BVoucherTabView.jsx",
        "routePaths": [
          "/my-page/b2b/voucher"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/AmazingPassPurchaseList.jsx",
        "routePaths": [
          "/my-page/amazingpass"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/GiftSendTabView.jsx",
        "routePaths": [
          "/my-page/gift-send"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/GiftTabView.jsx",
        "routePaths": [
          "/my-page/gift-box"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/ReservationList.tsx",
        "routePaths": [
          "/my-page/reservation"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/TicketPurchaseList.tsx",
        "routePaths": [
          "/my-page/ticket"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/UserVoucher.jsx",
        "routePaths": [
          "/my-page/voucher"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/Purchases.jsx",
        "routePaths": [
          "/purchases"
        ]
      }
    ]
  },
  {
    "id": "table",
    "label": "Table",
    "sourceFiles": [
      "src/Components/Common/Tailwind/Table.tsx"
    ],
    "usages": [
      {
        "pageFile": "src/pages/EventProduct/Reception/index.jsx",
        "routePaths": [
          "/reception/:type"
        ]
      },
      {
        "pageFile": "src/pages/Order/AddOptions/OrderDone.jsx",
        "routePaths": [
          "/add-options-order-done/:orderId"
        ]
      },
      {
        "pageFile": "src/pages/Order/OrderPackage/OrderFail.jsx",
        "routePaths": [
          "/order-fail"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/B2BCoupon/B2BTabView.jsx",
        "routePaths": [
          "/my-page/b2b/coupon"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/B2BPreCoupon/B2BPreCouponTabView.jsx",
        "routePaths": [
          "/my-page/b2b/precoupon"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/B2BVoucher/B2BVoucherTabView.jsx",
        "routePaths": [
          "/my-page/b2b/voucher"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/CancelList.jsx",
        "routePaths": [
          "/my-page/cancel"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/GiftSendTabView.jsx",
        "routePaths": [
          "/my-page/gift-send"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/GiftTabView.jsx",
        "routePaths": [
          "/my-page/gift-box"
        ]
      }
    ]
  },
  {
    "id": "datepicker",
    "label": "DatePicker",
    "sourceFiles": [
      "src/Components/Common/CommonDatePicker.tsx"
    ],
    "usages": [
      {
        "pageFile": "src/pages/Package/PackageItemPage.jsx",
        "routePaths": [
          "/package/:id"
        ]
      },
      {
        "pageFile": "src/pages/Package/PrivatePackageOfferPage.jsx",
        "routePaths": [
          "/private-package/:token"
        ]
      },
      {
        "pageFile": "src/pages/UserPage/purchaseList/ReservationList.tsx",
        "routePaths": [
          "/my-page/reservation"
        ]
      }
    ]
  },
  {
    "id": "paginated-table",
    "label": "Paginated Table",
    "sourceFiles": [
      "src/Components/Common/TableContainer.tsx",
      "src/Components/Common/TableContainerNew.tsx"
    ],
    "usages": [
      {
        "pageFile": "src/pages/EventProduct/Reception/index.jsx",
        "routePaths": [
          "/reception/:type"
        ]
      }
    ],
    "variants": [
      {
        "id": "table-container",
        "label": "TableContainer",
        "sourceFiles": [
          "src/Components/Common/TableContainer.tsx"
        ],
        "usages": [
          {
            "pageFile": "src/pages/EventProduct/Reception/index.jsx",
            "routePaths": [
              "/reception/:type"
            ]
          }
        ]
      },
      {
        "id": "table-container-new",
        "label": "TableContainerNew",
        "sourceFiles": [
          "src/Components/Common/TableContainerNew.tsx"
        ],
        "usages": []
      }
    ]
  }
];

export default sharedUiMetadata;
